var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn",on:{"click":_vm.handleBack}},[_c('svg',{staticClass:"back-icon",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"d":"M15 18l-6-6 6-6"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }